import React from "react";
import './index.css'
import { color } from "../../utils/themes/color";
import { Checkbox, Col, Row } from "antd";

export default function CHECKBOX(props) {

    const CheckboxGroup = Checkbox.Group;
    const plainOptions = [{ name: "sdf", value: "sdfsd" }, 'Pear', 'Orange'];





    return (

        <CheckboxGroup
            value={props.selectedItems != undefined ? props.selectedItems : ""}
            onChange={(e) => props.check(e)}>
            <Row style={{width:"100%"}} >
                {
                    props.items != null && props.items.lenght != 0 ?
                        props.items.map((itm, idx) => {
                            return (
                                <Col span={8}>
                                    <Checkbox key={idx} value={itm.value}> {itm.name} </Checkbox>
                                </Col>
                            )
                        })
                        : null
                }
            </Row>
        </CheckboxGroup>



    )

}


